import { ATTRS_LABEL, GENDER_OPTIONS } from '@meiqia/constants';

const deletedKeyList = ['created_on', 'updated_on', 'latest_conv_on', 'latest_visit_on', 'tag'];

const formatAttrConfig = attrSetting => {
  const dataAttrSettingShow = [];
  attrSetting.forEach(item => {
    // 要去掉tag,latest_visit_on等时间
    if (item.display && !deletedKeyList.includes(item.name)) {
      dataAttrSettingShow.push(item);
    }
  });
  dataAttrSettingShow.sort((a, b) => a.rank - b.rank);
  const data = [...dataAttrSettingShow];
  return data.map(value => {
    const { name, metainfo } = value;

    // 性别做特殊处理
    if (name === 'gender') {
      return {
        ...value,
        label: ATTRS_LABEL[name],
        type: 'radio',
        metainfo: GENDER_OPTIONS.map(val => ({ name: val.label, value: val.value }))
      };
    }
    // 处理metainfo
    if (metainfo && Array.isArray(metainfo) && metainfo.length) {
      return {
        ...value,
        label: ATTRS_LABEL[name] || name,
        metainfo: (metainfo && metainfo.map(val => ({ value: val, name: val }))) || []
      };
    }
    return { ...value, label: ATTRS_LABEL[name] || name };
  });
};

export default formatAttrConfig;
